import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { ViewProfile } from '@adornis/view-manager/db/ViewProfile.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';

@Entity()
export class ChancenViewProfile<T extends typeof AdornisEntity = typeof AdornisEntity> extends ViewProfile<T> {
  public static override _class = 'ChancenViewProfile';

  constructor(doc: PartialEntityData<ChancenViewProfile<T>>) {
    super(doc);
  }

  @DataLoadedField(type => ChancenwerkUser, ({ userID }) => userID)
  public user: Maybe<ChancenwerkUser>;

  @Field(type => String)
  public userID: Maybe<string>;

  @Field(type => [String])
  public availableForRoles: Maybe<string[]>;
}
